interface ClaimStatusBadgeProps {
    status: string;
}

const statusColors: Record<string, string> = {
    pending: 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30',
    approved: 'bg-green-500/20 text-green-400 border border-green-500/30',
    rejected: 'bg-red-500/20 text-red-400 border border-red-500/30',
};

export function ClaimStatusBadge({ status }: ClaimStatusBadgeProps) {
    const colorClasses = statusColors[status] ?? 'bg-gray-500/20 text-gray-400 border border-gray-500/30';

    return (
        <span className={`px-2 py-1 text-xs font-semibold rounded ${colorClasses}`}>
            {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
    );
}
